<template>
    <div>
        <FormInput label="Chat ID" :value="data.chat_id" hint="@channelusername or @groupusername" @update="data.chat_id=$event"></FormInput>
        <p>Magic variable 'chat_member_count' contains the number of members in a chat.</p>
    </div>
</template>

<script>
import FormInput from "@/components/tasks/fields/FormInput.vue";

export default {
    name: "GetChatMemberCount",
    components: {
        FormInput
    },
    props: {
        data: Object,
    }
}
</script>